import { months } from '@app/utils/months';
import { MemorialsRes } from '@app/objects/PetMemorial';

export const dateConvert = (memorial: MemorialsRes) => {
	return convertAllDates(memorial.birthday, memorial.dateOfPassing, memorial.dateCreated);
};

export const convertAllDates = (birthday: number | null, dateOfPassing: number | null, dateCreated: number) => {
	let dateBirth: string | null = null;
	let datePass: string | null = null;

	if (birthday) {
		const date1 = new Date(birthday);
		dateBirth = `${date1.getUTCMonth() + 1}/${date1.getUTCDate()}/${date1.getUTCFullYear()}`;
	}

	if (dateOfPassing) {
		const date2 = new Date(dateOfPassing);
		datePass = `${date2.getUTCMonth() + 1}/${date2.getUTCDate()}/${date2.getUTCFullYear()}`;
	}

	const date3 = new Date(dateCreated);
	const datePost = {
		month: months[date3.getMonth()],
		day: date3.getDate(),
		year: date3.getFullYear(),
	};

	return { dateBirth, datePass, datePost };
};
